export default __webpack_public_path__ + "media/images/react_icons/property/elevator-83d41c3f9068cac2e0d8fcafdf8b4a56.svg";